import { render, staticRenderFns } from "./ClientCallEntries.vue?vue&type=template&id=40aef184&"
import script from "./ClientCallEntries.vue?vue&type=script&lang=js&"
export * from "./ClientCallEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports